<div class="layout-row layout-align-start-center full-height"
     (mouseenter)="isShowEditButton=true"
     (mouseleave)="isShowEditButton=false">
  <span class="font-weight-400"
        [ngClass]="fontSize"
        [ngbTooltip]="tooltipTmpl"
        openDelay="300"
        triggers="hover"
        container="body">{{ (detailedServiceTime.generatedTotalTime || 0) | serviceTime }}
  </span>

  <bringoz-button *ngIf="isShowEditButton && isAllowEdit"
                  type="tertiary"
                  size="fit"
                  class="margin-left-5"
                  (onClick)="onToggleEdit($event)">
    <bringoz-icon iconName="edit" class="secondary-100"></bringoz-icon>
  </bringoz-button>

  <ng-template #tooltipTmpl>
    <div class="layout-column">
      <div class="layout-row layout-align-start-center margin-bottom-5">
        <span class="br-body-2 font-weight-600">{{ 'Entry Service Time' | translate }}:</span>
        <span
          class="br-body-2 font-weight-400 margin-left-5">{{ detailedServiceTime.entryTime | serviceTime }}</span>
      </div>
      <div class="layout-row layout-align-start-center margin-bottom-5">
        <span class="br-body-2 font-weight-600">{{ 'Exit Service Time' | translate }}:</span>
        <span
          class="br-body-2 font-weight-400 margin-left-5">{{ detailedServiceTime.exitTime | serviceTime }}</span>
      </div>
      <div class="layout-row layout-align-start-center margin-bottom-5">
        <span class="br-body-2 font-weight-600">{{ 'Subtasks Service Time' | translate }}:</span>
        <span
          class="br-body-2 font-weight-400 margin-left-5">{{ detailedServiceTime.subTasksTime | serviceTime }}</span>
      </div>
      <div class="layout-row layout-align-start-center margin-bottom-5">
        <span *ngIf="!ignorePackageServiceTime" class="br-body-2 font-weight-600">{{ 'Work Service Time' | translate }}
          :</span>
        <span *ngIf="ignorePackageServiceTime"
              class="br-body-2 font-weight-600">{{ 'Work & Packages Service Time' | translate }}:</span>
        <span
          class="br-body-2 font-weight-400 margin-left-5">{{ detailedServiceTime.workTime | serviceTime }}</span>
      </div>
      <div *ngIf="!ignorePackageServiceTime" class="layout-row layout-align-start-center">
        <span class="br-body-2 font-weight-600">{{ 'Packages Service Time' | translate }}:</span>
        <span
          class="br-body-2 font-weight-400 margin-left-5">{{ detailedServiceTime.packagesTime | serviceTime }}</span>
      </div>
    </div>
  </ng-template>
</div>
